import { Injectable, Pipe, PipeTransform } from "@angular/core";
import { HtmlDecoderService } from "../../services/services/html-decoder.service";

@Pipe({
    name: "htmlDecode",
    standalone: false
})
@Injectable()
export class HtmlDecodePipe implements PipeTransform {
  constructor(private htmlDecoderService: HtmlDecoderService) {}

  transform(value: string | null | undefined): string {
    if (value === null || value === undefined) return "";
    return this.htmlDecoderService.decodeHtmlEntities(value);
  }
}
